export const CHART_TOOLTIP_STYLE = {
  backgroundColor: '#1f2937',
  border: '1px solid #374151',
  borderRadius: '8px',
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '12px',
  color: '#FBFFEF',
} as const;

// Recharts overrides the outer `color` on its internal label/item text. These
// two styles are passed to <Tooltip labelStyle=... itemStyle=... /> to keep
// tooltip text readable against the dark figma theme.
export const CHART_TOOLTIP_LABEL_STYLE = {
  color: '#FBFFEF',
  fontFamily: 'Roboto, sans-serif',
  fontSize: '12px',
  fontWeight: 600,
} as const;

export const CHART_TOOLTIP_ITEM_STYLE = {
  color: '#FBFFEF',
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '12px',
} as const;

export const CHART_AXIS_STYLE = {
  fontSize: '12px',
  fontFamily: 'Roboto Mono, monospace',
} as const;

export const CHART_GRID_STROKE = '#374151';
export const CHART_AXIS_STROKE = '#9CA3AF';
export const CHART_PRIMARY_COLOR = '#c1f04f';
// Mirrors the `figma-lime` Tailwind token (#c1f04f). Recharts cell/bar
// fills can't accept Tailwind classes, so this is the canonical hex
// reference for code paths that need a literal color value matching the
// design system. Keep in lockstep with the token in tailwind.config.js.
export const CHART_ACCENT_COLOR = '#c1f04f';
